export function blobToBase64(blob) {
    return new Promise(function (resolve) {
        var reader = new FileReader();
        reader.onloadend = function () { return resolve(reader.result); };
        reader.readAsDataURL(blob);
    });
}
